import { render, staticRenderFns } from "./TemplateGeneratorLogo.vue?vue&type=template&id=b5e553ea&"
import script from "./TemplateGeneratorLogo.vue?vue&type=script&lang=js&"
export * from "./TemplateGeneratorLogo.vue?vue&type=script&lang=js&"
import style0 from "./TemplateGeneratorLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports